import styled from 'styled-components/macro'
import { BREAK_ } from 'constants'

export const Space = styled.div`
  flex:0 0 ${({m})=>m}px;
  ${ BREAK_.md_up } { 
    flex:0 0 ${({d})=>d}px;
  }
`